import { render, staticRenderFns } from "./serveTab8.vue?vue&type=template&id=68e3b880&scoped=true"
import script from "./serveTab8.vue?vue&type=script&lang=js"
export * from "./serveTab8.vue?vue&type=script&lang=js"
import style0 from "./serveTab8.vue?vue&type=style&index=0&id=68e3b880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3b880",
  null
  
)

export default component.exports